module.exports = __webpack_public_path__ + "img/car_icon02.41740ab4.png";